<mat-card>
    <mat-card-content>
      <div class="info-section"><!--Service Information-->
        <h1 class="section-header">Service Information</h1>
        <ol>
          <li>
            <a (click)="scrollService.scrollTo('s_name')">Service Name</a>  
          </li>
          <li>
            <a (click)="scrollService.scrollTo('s_info')">Service Description</a>  
          </li>
          <li>
            <a (click)="scrollService.scrollTo('s_ood')">Office or Division</a>  
          </li>
          <li>
            <a (click)="scrollService.scrollTo('s_cat')">Category</a>  
          </li>
          <li>
            <a (click)="scrollService.scrollTo('s_class')">Classification</a>  
          </li>
          <li>
            <a (click)="scrollService.scrollTo('s_tot')">Type of Transaction</a>  
          </li>
          <li>
            <a (click)="scrollService.scrollTo('s_wma')">Who may avail</a>  
          </li>
          <li>
            <a (click)="scrollService.scrollTo('s_oh')">Operating Hours</a>  
          </li>
          <li *ngIf="services.serviceDetails.has_statute == true">
            <a (click)="scrollService.scrollTo('s_stt')">Statute</a>  
          </li>
        </ol>
      </div>

      <!--Service Requirement-->
      <div class="req-section">
        <h1 class="section-header">Service Requirements</h1>
        <!--Standard Requirements-->
        <div class="std-sec" >
            <h1 class="section-subheader">Standard Requirements</h1>

            <!-- 1️ No requirements at all -->
            <ng-container *ngIf="(!services.standardRequirements || services.standardRequirements.length === 0) && (!services.situationalRequirementsArray || services.situationalRequirementsArray.length === 0)">
              <p>No Requirements Needed.</p>
            </ng-container>

            <!-- 2️ Render standard requirements -->
            <ng-container *ngIf="services.standardRequirements?.length > 0">
              <ol>
                <ng-container *ngFor="let req of services.standardRequirements; let i = index">
                  <ng-container
                    *ngTemplateOutlet="requirementTree; context: {
                      $implicit: req,
                      prefix: [requirementservice.printNumber(i)],
                      depth: 1
                    }"></ng-container>
                </ng-container>
              </ol>
            </ng-container>
        </div>

        <div class="sit-rec">
           
          <!-- 3 Render situational requirements -->
            <ng-container *ngIf="services.situationalRequirementsArray?.length > 0">
              <h1 class="section-subheader">Situational Requirements</h1>
           <ol>
              <ng-container *ngFor="let sit of services.situationalRequirementsArray; let i = index">
                <li>
                <a class="req-link" (click)="scrollService.scrollTo('req_' + requirementservice.printLetter(i))" matTooltip="{{ sit.title }}">{{ requirementservice.printLetter(i) }}. {{ sit.title }}</a>
                  <ol>
                    <ng-container *ngFor="let req of sit.requirement; let r = index">
                      <ng-container
                        *ngTemplateOutlet="requirementTree; context: {
                          $implicit: req,
                          prefix: [requirementservice.printLetter(i), requirementservice.printNumber(r)],
                          depth: 2
                        }"
                      ></ng-container>
                    </ng-container>
                  </ol>

                  <!-- SubSituations -->
                  <ol *ngIf="sit.subRequirement?.length > 0">
                    <ng-container *ngFor="let sub of sit.subRequirement; let subIndex = index">
                      <li>
                        <a class="req-link" (click)="scrollService.scrollTo('req_' + requirementservice.printLetter(i) + '.' + requirementservice.printLetter(subIndex).toLowerCase())" matTooltip="{{ sub.title }}">
                        {{ requirementservice.printLetter(i) }}.{{ requirementservice.printLetter(subIndex).toLowerCase() }}. {{ sub.title }} </a>
                        <ol>
                          <ng-container *ngFor="let req of sub.requirement; let r = index">
                            <ng-container
                              *ngTemplateOutlet="requirementTree; context: {
                                $implicit: req,
                                prefix: [
                                  requirementservice.printLetter(i),
                                  requirementservice.printLetter(subIndex).toLowerCase(),
                                  requirementservice.printNumber(r)
                                ],
                                depth: 3
                              }"
                            ></ng-container>
                          </ng-container>
                        </ol>
                      </li>
                    </ng-container>
                  </ol>
                </li>
              </ng-container>
            </ol>
            </ng-container>
        </div>
          <!-- Recursive Template (no prefix version) -->
          <ng-template #requirementTree let-req let-prefix="prefix" let-depth="depth">
          <!-- STANDARD -->
          <li *ngIf="!req.chooseany">
            <a class="req-link" (click)="scrollService.scrollTo('req_' + requirementservice.joinPrefix(prefix))" matTooltip="{{ req.requirement }}" > {{ requirementservice.joinPrefix(prefix) }}. {{ req.requirement }}</a>
            <!-- SubRequirement -->
            <ul *ngIf="req.subRequirement?.length > 0">
              <li *ngFor="let sub of req.subRequirement; let subIndex = index">
                <a class="req-link" *ngIf="sub.title" (click)="scrollService.scrollTo('req_' + requirementservice.joinPrefix(prefix) + '.' + requirementservice.printLetter(subIndex))" matTooltip="{{ sub.title }}">
                  {{ requirementservice.joinPrefix(prefix) }}.{{ requirementservice.printLetter(subIndex) }}. {{ sub.title }}</a>
                <ul>
                  <ng-container *ngFor="let child of sub.requirement; let childIndex = index">
                    <ng-container
                      *ngTemplateOutlet="requirementTree; context: {
                        $implicit: child,
                        prefix: prefix.concat([requirementservice.printLetter(subIndex), requirementservice.printNumber(childIndex)]),
                        depth: depth + 2
                      }"
                    ></ng-container>
                  </ng-container>
                </ul>
              </li>
            </ul>
          </li>

          <!-- CHOOSE ANY -->
          <li *ngIf="req.chooseany">
            <a (click)="scrollService.scrollTo('req_' + requirementservice.joinPrefix(prefix))" matTooltip="{{ req.title }}" class="req-link" >
              {{ requirementservice.joinPrefix(prefix) }}. {{ req.title }}</a>
            <p class="p-0 m-0"><small>Any of the following:</small></p>
            <ol>
              <ng-container *ngFor="let opt of req.requirement; let optIndex = index" style="border: 5px solid black;"> 
                <ng-container
                  *ngTemplateOutlet="requirementTree; context: {
                    $implicit: opt,
                    prefix: prefix.concat([requirementservice.printLetter(optIndex)]),
                    depth: depth + 1
                  }"
                ></ng-container>
              </ng-container>
            </ol>
          </li>
        </ng-template>

      </div> 

 
      
  <!--Client Steps-->
  <div class="cs-section">
    <div>
      <h1 class="section-header">Client Steps and Agency Actions</h1>
    </div>
    <div style="width: 80%;" *ngIf="services.processedClientStep && services.processedClientStep.length > 0">
      <ol>
              <li *ngFor="let clientStep of services.processedClientStep">
                <a class="req-link" (click)="scrollService.scrollTo(clientStep.step_Id)" matTooltip="{{clientStep.clientStepName}}" >{{clientStep.clientStepName}}</a> 
              <ol class="">
                  <div *ngIf="clientStep.isSituationalStep == true" class="situational-header" matTooltip="* For {{clientStep.situation}}">* For {{clientStep.situation}}</div>
                  <li><a class="req-link" (click)="scrollService.scrollTo(clientStep.action_Id)" matTooltip="{{clientStep.agencyActions}}">{{clientStep.agencyActions}}</a></li>
              </ol>
            </li>
        </ol>
    </div>
  </div>

<!--TIme and fees-->
  <div class="tf-section">
        <ol class="p-0">
          <li>
            <a  (click)="scrollService.scrollTo('tpt')">Total Processing Time</a>  
          </li>
          <li>
            <a  (click)="scrollService.scrollTo('tpf')">Total Processing Fee</a>  
          </li>
          <li>
            <a  (click)="scrollService.scrollTo('lpf')">List Of Possible Fees</a>  
          </li>
          <li>
            <a  (click)="scrollService.scrollTo('lff')">List of Formulated Fees</a>  
          </li>
        </ol>  
      </div>    
    </mat-card-content>
  </mat-card>